export const Excel_Formats = {
    Accounting: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
    Percentage: '0.00%'
};

const Border_Thin = { style: "thin", color: { rgb: "000000" } };

export const Excel_Styles = {
    metadataTitle: {
        fill: { fgColor: { rgb: "7a8580" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
        border: { right: Border_Thin }
    },
    greyRow: {
        fill: { fgColor: { rgb: "F2F2F2" } },
        font: { color: { rgb: "7F7F7F" } },
        alignment: { horizontal: "left" }
    },
    editable: {
        fill: { fgColor: { rgb: "FFFFFF" } },
        font: { color: { rgb: "000000" } },
        border: {
            top: Border_Thin,
            bottom: Border_Thin,
            left: Border_Thin,
            right: Border_Thin
        },
        alignment: { horizontal: "left" }
    },
    header: {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "89a39e" } },
        alignment: { horizontal: "center" }
    }
};